// source: scenetree/protos/domain.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var core_protos_uuid_pb = require('../../core/protos/uuid_pb.js');
goog.object.extend(proto, core_protos_uuid_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.IndexingStatus', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.Node', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.Range', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.SealedValueCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.scenetree.v1alpha1.Node.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.Node, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.Node.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.Node';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Range = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.Range, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.Range.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.Range';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.repeatedFields_, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.oneofGroups_);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey.displayName = 'proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.Node.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && core_protos_uuid_pb.Uuid.toObject(includeInstance, f),
    depth: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    visible: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    selected: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    expanded: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    isLeaf: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    suppliedId: (f = msg.getSuppliedId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    partiallyVisible: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    columnsList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    filterHit: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    phantom: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    endItem: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    hasGeometry: jspb.Message.getBooleanFieldWithDefault(msg, 14, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.Node;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.Node.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid;
      reader.readMessage(value,core_protos_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDepth(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVisible(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSelected(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExpanded(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLeaf(value);
      break;
    case 8:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSuppliedId(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPartiallyVisible(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addColumns(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFilterHit(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPhantom(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEndItem(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasGeometry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.Node.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
  f = message.getDepth();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVisible();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getSelected();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getExpanded();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getIsLeaf();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getSuppliedId();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPartiallyVisible();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getColumnsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getFilterHit();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getPhantom();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getEndItem();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getHasGeometry();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.getId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint32 depth = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.getDepth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.setDepth = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool visible = 4;
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.getVisible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.setVisible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool selected = 5;
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.getSelected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.setSelected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool expanded = 6;
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.getExpanded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.setExpanded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool is_leaf = 7;
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.getIsLeaf = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.setIsLeaf = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional google.protobuf.StringValue supplied_id = 8;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.getSuppliedId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 8));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.setSuppliedId = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.clearSuppliedId = function() {
  return this.setSuppliedId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.hasSuppliedId = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool partially_visible = 9;
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.getPartiallyVisible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.setPartiallyVisible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * repeated string columns = 10;
 * @return {!Array<string>}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.getColumnsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.setColumnsList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.addColumns = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.clearColumnsList = function() {
  return this.setColumnsList([]);
};


/**
 * optional bool filter_hit = 11;
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.getFilterHit = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.setFilterHit = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool phantom = 12;
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.getPhantom = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.setPhantom = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool end_item = 13;
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.getEndItem = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.setEndItem = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool has_geometry = 14;
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.getHasGeometry = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Node} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Node.prototype.setHasGeometry = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStart(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 start = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange.prototype.setStart = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Range.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.Range.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.Range} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Range.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: jspb.Message.getFieldWithDefault(msg, 1, 0),
    end: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Range}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Range.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.Range;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.Range.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.Range} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Range}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Range.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStart(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Range.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.Range.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.Range} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Range.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getEnd();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 start = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Range.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Range} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Range.prototype.setStart = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 end = 2;
 * @return {number}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Range.prototype.getEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Range} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.Range.prototype.setEnd = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.repeatedFields_ = [1,2,3,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.toObject = function(includeInstance, msg) {
  var f, obj = {
    hiddenList: jspb.Message.toObjectList(msg.getHiddenList(),
    proto.vertexvis.protobuf.scenetree.v1alpha1.Range.toObject, includeInstance),
    shownList: jspb.Message.toObjectList(msg.getShownList(),
    proto.vertexvis.protobuf.scenetree.v1alpha1.Range.toObject, includeInstance),
    selectedList: jspb.Message.toObjectList(msg.getSelectedList(),
    proto.vertexvis.protobuf.scenetree.v1alpha1.Range.toObject, includeInstance),
    deselectedList: jspb.Message.toObjectList(msg.getDeselectedList(),
    proto.vertexvis.protobuf.scenetree.v1alpha1.Range.toObject, includeInstance),
    partiallyVisibleList: jspb.Message.toObjectList(msg.getPartiallyVisibleList(),
    proto.vertexvis.protobuf.scenetree.v1alpha1.Range.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.scenetree.v1alpha1.Range;
      reader.readMessage(value,proto.vertexvis.protobuf.scenetree.v1alpha1.Range.deserializeBinaryFromReader);
      msg.addHidden(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.scenetree.v1alpha1.Range;
      reader.readMessage(value,proto.vertexvis.protobuf.scenetree.v1alpha1.Range.deserializeBinaryFromReader);
      msg.addShown(value);
      break;
    case 3:
      var value = new proto.vertexvis.protobuf.scenetree.v1alpha1.Range;
      reader.readMessage(value,proto.vertexvis.protobuf.scenetree.v1alpha1.Range.deserializeBinaryFromReader);
      msg.addSelected(value);
      break;
    case 4:
      var value = new proto.vertexvis.protobuf.scenetree.v1alpha1.Range;
      reader.readMessage(value,proto.vertexvis.protobuf.scenetree.v1alpha1.Range.deserializeBinaryFromReader);
      msg.addDeselected(value);
      break;
    case 5:
      var value = new proto.vertexvis.protobuf.scenetree.v1alpha1.Range;
      reader.readMessage(value,proto.vertexvis.protobuf.scenetree.v1alpha1.Range.deserializeBinaryFromReader);
      msg.addPartiallyVisible(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHiddenList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.vertexvis.protobuf.scenetree.v1alpha1.Range.serializeBinaryToWriter
    );
  }
  f = message.getShownList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.vertexvis.protobuf.scenetree.v1alpha1.Range.serializeBinaryToWriter
    );
  }
  f = message.getSelectedList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.vertexvis.protobuf.scenetree.v1alpha1.Range.serializeBinaryToWriter
    );
  }
  f = message.getDeselectedList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.vertexvis.protobuf.scenetree.v1alpha1.Range.serializeBinaryToWriter
    );
  }
  f = message.getPartiallyVisibleList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.vertexvis.protobuf.scenetree.v1alpha1.Range.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Range hidden = 1;
 * @return {!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Range>}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.getHiddenList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Range>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vertexvis.protobuf.scenetree.v1alpha1.Range, 1));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Range>} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.setHiddenList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.Range=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Range}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.addHidden = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vertexvis.protobuf.scenetree.v1alpha1.Range, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.clearHiddenList = function() {
  return this.setHiddenList([]);
};


/**
 * repeated Range shown = 2;
 * @return {!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Range>}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.getShownList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Range>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vertexvis.protobuf.scenetree.v1alpha1.Range, 2));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Range>} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.setShownList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.Range=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Range}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.addShown = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vertexvis.protobuf.scenetree.v1alpha1.Range, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.clearShownList = function() {
  return this.setShownList([]);
};


/**
 * repeated Range selected = 3;
 * @return {!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Range>}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.getSelectedList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Range>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vertexvis.protobuf.scenetree.v1alpha1.Range, 3));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Range>} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.setSelectedList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.Range=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Range}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.addSelected = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.vertexvis.protobuf.scenetree.v1alpha1.Range, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.clearSelectedList = function() {
  return this.setSelectedList([]);
};


/**
 * repeated Range deselected = 4;
 * @return {!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Range>}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.getDeselectedList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Range>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vertexvis.protobuf.scenetree.v1alpha1.Range, 4));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Range>} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.setDeselectedList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.Range=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Range}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.addDeselected = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.vertexvis.protobuf.scenetree.v1alpha1.Range, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.clearDeselectedList = function() {
  return this.setDeselectedList([]);
};


/**
 * repeated Range partially_visible = 5;
 * @return {!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Range>}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.getPartiallyVisibleList = function() {
  return /** @type{!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Range>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.vertexvis.protobuf.scenetree.v1alpha1.Range, 5));
};


/**
 * @param {!Array<!proto.vertexvis.protobuf.scenetree.v1alpha1.Range>} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.setPartiallyVisibleList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.Range=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.Range}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.addPartiallyVisible = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.vertexvis.protobuf.scenetree.v1alpha1.Range, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.prototype.clearPartiallyVisibleList = function() {
  return this.setPartiallyVisibleList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange.toObject = function(includeInstance, msg) {
  var f, obj = {
    numberOfResults: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNumberOfResults();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 number_of_results = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange.prototype.getNumberOfResults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange.prototype.setNumberOfResults = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.SealedValueCase = {
  SEALED_VALUE_NOT_SET: 0,
  LIST_CHANGE: 1,
  RANGES: 2,
  KEEP_ALIVE: 3,
  FILTER_CHANGE: 4
};

/**
 * @return {proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.SealedValueCase}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.getSealedValueCase = function() {
  return /** @type {proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.SealedValueCase} */(jspb.Message.computeOneofCase(this, proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.toObject = function(includeInstance, msg) {
  var f, obj = {
    listChange: (f = msg.getListChange()) && proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange.toObject(includeInstance, f),
    ranges: (f = msg.getRanges()) && proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.toObject(includeInstance, f),
    keepAlive: (f = msg.getKeepAlive()) && proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive.toObject(includeInstance, f),
    filterChange: (f = msg.getFilterChange()) && proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange;
      reader.readMessage(value,proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange.deserializeBinaryFromReader);
      msg.setListChange(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange;
      reader.readMessage(value,proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.deserializeBinaryFromReader);
      msg.setRanges(value);
      break;
    case 3:
      var value = new proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive;
      reader.readMessage(value,proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive.deserializeBinaryFromReader);
      msg.setKeepAlive(value);
      break;
    case 4:
      var value = new proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange;
      reader.readMessage(value,proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange.deserializeBinaryFromReader);
      msg.setFilterChange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListChange();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange.serializeBinaryToWriter
    );
  }
  f = message.getRanges();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange.serializeBinaryToWriter
    );
  }
  f = message.getKeepAlive();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive.serializeBinaryToWriter
    );
  }
  f = message.getFilterChange();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange.serializeBinaryToWriter
    );
  }
};


/**
 * optional ListChange list_change = 1;
 * @return {?proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.getListChange = function() {
  return /** @type{?proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.scenetree.v1alpha1.ListChange|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.setListChange = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.clearListChange = function() {
  return this.setListChange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.hasListChange = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional StateChange ranges = 2;
 * @return {?proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.getRanges = function() {
  return /** @type{?proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.scenetree.v1alpha1.StateChange|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.setRanges = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.clearRanges = function() {
  return this.setRanges(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.hasRanges = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional KeepAlive keep_alive = 3;
 * @return {?proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.getKeepAlive = function() {
  return /** @type{?proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.scenetree.v1alpha1.KeepAlive|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.setKeepAlive = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.clearKeepAlive = function() {
  return this.setKeepAlive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.hasKeepAlive = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional FilterChange filter_change = 4;
 * @return {?proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.getFilterChange = function() {
  return /** @type{?proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange, 4));
};


/**
 * @param {?proto.vertexvis.protobuf.scenetree.v1alpha1.FilterChange|undefined} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType} returns this
*/
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.setFilterChange = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.clearFilterChange = function() {
  return this.setFilterChange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.TreeChangeType.prototype.hasFilterChange = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey;
  return proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey} returns this
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.ColumnKey.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.vertexvis.protobuf.scenetree.v1alpha1.IndexingStatus = {
  INDEXING_STATUS_INVALID: 0,
  INDEXING_STATUS_INDEXING: 1,
  INDEXING_STATUS_READY: 2
};

goog.object.extend(exports, proto.vertexvis.protobuf.scenetree.v1alpha1);
